/* Sold-out visibility fix: marks unavailable swatch options and disables the wizard button */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('[data-variant-picker]');
    var form = document.querySelector('[data-product-form]');
    var btn = document.querySelector('[data-flow-next][data-for-step="1"]');
    var jsonEl = wrap && wrap.querySelector('[data-variants-json]');
    if (!form || !btn) return;

    var variants = [];
    if (jsonEl) { try { variants = JSON.parse(jsonEl.textContent); } catch (e) {} }

    if (!btn.dataset.origHtml) btn.dataset.origHtml = btn.innerHTML;

    function selectedValues() {
      var sel = [];
      if (!wrap) return sel;
      wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) sel[parseInt(group.dataset.optionIndex, 10)] = checked.value;
      });
      return sel;
    }
    function currentMatch() {
      if (!variants.length) return null;
      var sel = selectedValues();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      }) || null;
    }
    function setButton(available) {
      if (available) {
        btn.disabled = false;
        btn.classList.remove('is-soldout');
        btn.innerHTML = btn.dataset.origHtml;
      } else {
        btn.disabled = true;
        btn.classList.add('is-soldout');
        btn.textContent = 'Sold out';
      }
    }
    function markSwatches() {
      if (!wrap || !variants.length) return;
      var sel = selectedValues();
      wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
        var gi = parseInt(group.dataset.optionIndex, 10);
        group.querySelectorAll('.pj-swatch').forEach(function (label) {
          var input = label.querySelector('input');
          if (!input) return;
          var value = input.value;
          // available if ANY variant matches this value here + the other groups' current selections
          var ok = variants.some(function (v) {
            if (!v.available) return false;
            if (v.options[gi] !== value) return false;
            return v.options.every(function (opt, i) {
              return i === gi || !sel[i] || opt === sel[i];
            });
          });
          label.classList.toggle('is-soldout', !ok);
        });
      });
    }
    function refresh() {
      markSwatches();
      if (variants.length) {
        var m = currentMatch();
        setButton(!!(m && m.available));
      }
    }
    /* no picker on the page (single-variant product): check availability via product JSON */
    if (!variants.length) {
      var pathMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
      if (pathMatch) {
        fetch('/products/' + pathMatch[1] + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            variants = p.variants.map(function (v) { return { id: v.id, options: v.options, available: v.available }; });
            var idInput = form.querySelector('[name="id"]');
            var cur = variants.find(function (v) { return String(v.id) === String(idInput && idInput.value); });
            setButton(!!(cur ? cur.available : p.available));
          }).catch(function () {});
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-input]')) setTimeout(refresh, 0);
    });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
